// Panel Pros logo: a navy badge with a polished-panel curve + orange shine spark,
// alongside the wordmark. `light` renders white text for dark backgrounds.
export const Logo = ({ light = false, className = "" }) => (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
        <span className="relative inline-grid place-items-center group-hover:-translate-y-0.5 transition-transform duration-200">
            <svg
                width="38"
                height="38"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                className="drop-shadow-sm"
            >
                <rect width="48" height="48" rx="13" fill="#0B1F33" />
                <rect
                    x="1"
                    y="1"
                    width="46"
                    height="46"
                    rx="12"
                    stroke="#F47B20"
                    strokeOpacity="0.25"
                    strokeWidth="1.5"
                />
                {/* polished panel curve */}
                <path
                    d="M11 32 Q24 19 37 32"
                    stroke="#FFFFFF"
                    strokeWidth="3.2"
                    fill="none"
                    strokeLinecap="round"
                />
                <path
                    d="M15 35.5 Q24 27 33 35.5"
                    stroke="#F47B20"
                    strokeWidth="2.4"
                    fill="none"
                    strokeLinecap="round"
                />
                {/* shine spark */}
                <path
                    d="M24 7.5 l1.7 4.3 4.3 1.7 -4.3 1.7 -1.7 4.3 -1.7-4.3 -4.3-1.7 4.3-1.7 z"
                    fill="#F47B20"
                />
            </svg>
        </span>
        <span
            className={`font-display font-bold text-[1.35rem] leading-none tracking-tight ${
                light ? "text-white" : "text-navy"
            }`}
        >
            Panel<span className="text-safety">Pros</span>
        </span>
    </span>
);
